const svgToDataUri = (svg) => `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;

export const LABEL_BACKGROUND_THEMES = [
  {
    key: "floral-mist",
    label: "Floral Mist",
    url: svgToDataUri(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 700">
        <defs>
          <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#fff7da"/>
            <stop offset="100%" stop-color="#ffe4d4"/>
          </linearGradient>
        </defs>
        <rect width="1000" height="700" fill="url(#bg)"/>
        <g fill="none" stroke="#d48b8b" stroke-width="8" opacity="0.42">
          <path d="M130 540c60-200 160-310 300-330"/>
          <path d="M870 160c-70 170-200 280-370 320"/>
          <path d="M470 170c-10 90-50 170-120 240"/>
        </g>
        <g fill="#f6c8c2" opacity="0.38">
          <circle cx="210" cy="170" r="78"/>
          <circle cx="830" cy="530" r="96"/>
          <circle cx="670" cy="180" r="55"/>
        </g>
        <g fill="#ffffff" opacity="0.6">
          <circle cx="240" cy="140" r="18"/>
          <circle cx="270" cy="190" r="10"/>
          <circle cx="790" cy="500" r="16"/>
          <circle cx="860" cy="560" r="11"/>
        </g>
      </svg>
    `),
  },
  {
    key: "violet-tiles",
    label: "Violet Tiles",
    url: svgToDataUri(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 700">
        <rect width="1000" height="700" fill="#eef0ff"/>
        <g opacity="0.55">
          <polygon points="0,0 180,0 90,150" fill="#7e78b8"/>
          <polygon points="180,0 360,0 260,150" fill="#5b568b"/>
          <polygon points="360,0 560,0 450,170" fill="#938dd1"/>
          <polygon points="560,0 770,0 660,160" fill="#6a649f"/>
          <polygon points="770,0 1000,0 890,180" fill="#8a82bf"/>
          <polygon points="0,140 160,300 0,360" fill="#6e6aa3"/>
          <polygon points="160,140 360,300 160,430" fill="#8f8ac5"/>
          <polygon points="360,170 590,340 310,470" fill="#5e598f"/>
          <polygon points="590,160 820,340 560,510" fill="#847db8"/>
          <polygon points="820,180 1000,320 840,520" fill="#645f97"/>
          <polygon points="0,360 250,700 0,700" fill="#817aba"/>
          <polygon points="250,430 520,700 120,700" fill="#6a659d"/>
          <polygon points="520,510 760,700 360,700" fill="#928bd0"/>
          <polygon points="760,520 1000,700 650,700" fill="#706aa7"/>
        </g>
      </svg>
    `),
  },
  {
    key: "leafy-sage",
    label: "Leafy Sage",
    url: svgToDataUri(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 700">
        <defs>
          <linearGradient id="bg" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#f7fff2"/>
            <stop offset="100%" stop-color="#dff1d6"/>
          </linearGradient>
        </defs>
        <rect width="1000" height="700" fill="url(#bg)"/>
        <g fill="#6a8f61" opacity="0.32">
          <ellipse cx="160" cy="130" rx="110" ry="45" transform="rotate(-24 160 130)"/>
          <ellipse cx="340" cy="240" rx="130" ry="55" transform="rotate(18 340 240)"/>
          <ellipse cx="760" cy="180" rx="150" ry="58" transform="rotate(-14 760 180)"/>
          <ellipse cx="630" cy="470" rx="170" ry="62" transform="rotate(20 630 470)"/>
          <ellipse cx="220" cy="560" rx="135" ry="55" transform="rotate(-12 220 560)"/>
        </g>
        <g stroke="#8fb184" stroke-width="5" opacity="0.28">
          <path d="M120 650C230 430 350 330 500 260"/>
          <path d="M820 80C720 260 610 350 450 420"/>
        </g>
      </svg>
    `),
  },
  {
    key: "sunrise-wave",
    label: "Sunrise Wave",
    url: svgToDataUri(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 700">
        <defs>
          <linearGradient id="sky" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#fff3dc"/>
            <stop offset="100%" stop-color="#ffd3bb"/>
          </linearGradient>
        </defs>
        <rect width="1000" height="700" fill="url(#sky)"/>
        <path d="M0 420C150 360 280 360 430 420C560 470 700 470 1000 360V700H0Z" fill="#f2a06f" opacity="0.34"/>
        <path d="M0 510C180 430 360 450 520 520C670 580 820 580 1000 490V700H0Z" fill="#dc7b73" opacity="0.28"/>
        <circle cx="790" cy="140" r="78" fill="#fff9d2" opacity="0.78"/>
      </svg>
    `),
  },
  {
    key: "royal-mosaic",
    label: "Royal Mosaic",
    url: svgToDataUri(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 700">
        <rect width="1000" height="700" fill="#f4f0ff"/>
        <g opacity="0.68">
          <path d="M0 0h220L80 180H0Z" fill="#62539c"/>
          <path d="M220 0h240L300 190H80Z" fill="#8877cc"/>
          <path d="M460 0h250L540 200H300Z" fill="#4f437f"/>
          <path d="M710 0h290L820 220H540Z" fill="#7464b8"/>
          <path d="M0 180h280L150 380H0Z" fill="#8979c1"/>
          <path d="M280 180h260L350 430H150Z" fill="#584a8b"/>
          <path d="M540 200h280L620 450H350Z" fill="#9a8dd8"/>
          <path d="M820 220h180V470H620Z" fill="#6b5ca7"/>
          <path d="M0 380h300L120 700H0Z" fill="#6f61aa"/>
          <path d="M300 430h340L380 700H120Z" fill="#8d82cb"/>
          <path d="M640 450h360V700H380Z" fill="#56487e"/>
        </g>
      </svg>
    `),
  },
  {
    key: "lotus-gold",
    label: "Lotus Gold",
    url: svgToDataUri(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 700">
        <defs>
          <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#fff8e7"/>
            <stop offset="100%" stop-color="#ffe8c0"/>
          </linearGradient>
        </defs>
        <rect width="1000" height="700" fill="url(#bg)"/>
        <g fill="none" stroke="#c99949" stroke-width="10" opacity="0.28">
          <circle cx="240" cy="220" r="120"/>
          <circle cx="740" cy="470" r="150"/>
          <path d="M500 120c70 40 110 110 120 210"/>
        </g>
        <g fill="#d9a85a" opacity="0.35">
          <path d="M220 260c40-90 100-120 160-100-40 70-90 110-160 100Z"/>
          <path d="M630 510c50-110 130-150 230-130-50 90-120 150-230 130Z"/>
          <path d="M450 250c40-70 100-90 170-60-40 60-90 90-170 60Z"/>
        </g>
      </svg>
    `),
  },
  {
    key: "mint-dots",
    label: "Mint Dots",
    url: svgToDataUri(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 700">
        <rect width="1000" height="700" fill="#f3fff9"/>
        <g fill="#89cdb3" opacity="0.34">
          <circle cx="110" cy="120" r="48"/>
          <circle cx="280" cy="210" r="24"/>
          <circle cx="420" cy="110" r="40"/>
          <circle cx="610" cy="220" r="58"/>
          <circle cx="810" cy="120" r="30"/>
          <circle cx="920" cy="260" r="52"/>
          <circle cx="180" cy="440" r="66"/>
          <circle cx="370" cy="520" r="28"/>
          <circle cx="560" cy="430" r="38"/>
          <circle cx="730" cy="560" r="74"/>
          <circle cx="900" cy="460" r="34"/>
        </g>
        <g fill="#d8fff0" opacity="0.9">
          <circle cx="210" cy="170" r="10"/>
          <circle cx="470" cy="160" r="12"/>
          <circle cx="720" cy="180" r="9"/>
          <circle cx="250" cy="490" r="11"/>
          <circle cx="640" cy="500" r="10"/>
        </g>
      </svg>
    `),
  },
  {
    key: "indigo-bloom",
    label: "Indigo Bloom",
    url: svgToDataUri(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 700">
        <defs>
          <linearGradient id="bg" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#eef1ff"/>
            <stop offset="100%" stop-color="#d9def9"/>
          </linearGradient>
        </defs>
        <rect width="1000" height="700" fill="url(#bg)"/>
        <g fill="#5f5bb2" opacity="0.25">
          <path d="M150 560c70-120 130-170 260-220-20 150-90 230-260 220Z"/>
          <path d="M760 180c-90 130-170 200-320 240 30-170 120-250 320-240Z"/>
          <path d="M420 250c40-80 90-120 180-130-20 90-80 140-180 130Z"/>
        </g>
        <g stroke="#7a74d0" stroke-width="6" fill="none" opacity="0.32">
          <path d="M120 620c150-150 270-230 430-290"/>
          <path d="M870 120C710 250 610 330 470 410"/>
        </g>
      </svg>
    `),
  },
  {
    key: "peach-weave",
    label: "Peach Weave",
    url: svgToDataUri(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 700">
        <rect width="1000" height="700" fill="#fff5f1"/>
        <g stroke="#efb39d" stroke-width="18" opacity="0.22">
          <path d="M-40 120h1080"/>
          <path d="M-40 260h1080"/>
          <path d="M-40 400h1080"/>
          <path d="M-40 540h1080"/>
          <path d="M160 -40v780"/>
          <path d="M360 -40v780"/>
          <path d="M560 -40v780"/>
          <path d="M760 -40v780"/>
        </g>
        <g fill="#ffd7c8" opacity="0.3">
          <circle cx="160" cy="120" r="40"/>
          <circle cx="560" cy="400" r="50"/>
          <circle cx="760" cy="540" r="44"/>
        </g>
      </svg>
    `),
  },
  {
    key: "forest-arch",
    label: "Forest Arch",
    url: svgToDataUri(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 700">
        <defs>
          <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#eef8ec"/>
            <stop offset="100%" stop-color="#d1ead0"/>
          </linearGradient>
        </defs>
        <rect width="1000" height="700" fill="url(#bg)"/>
        <path d="M0 700c120-230 250-340 430-370-50 220-180 360-430 370Z" fill="#5f8e5d" opacity="0.24"/>
        <path d="M1000 0c-140 240-290 360-500 390 60-220 220-370 500-390Z" fill="#7aaa73" opacity="0.24"/>
        <g stroke="#87af81" stroke-width="6" opacity="0.25" fill="none">
          <path d="M110 610c120-140 250-240 430-310"/>
          <path d="M890 90C760 220 630 310 450 370"/>
        </g>
      </svg>
    `),
  },
  {
    key: "ruby-festive",
    label: "Ruby Festive",
    url: svgToDataUri(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 700">
        <defs>
          <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#fff3f1"/>
            <stop offset="100%" stop-color="#ffe2de"/>
          </linearGradient>
        </defs>
        <rect width="1000" height="700" fill="url(#bg)"/>
        <g fill="#c84b58" opacity="0.28">
          <circle cx="180" cy="150" r="72"/>
          <circle cx="840" cy="180" r="54"/>
          <circle cx="700" cy="520" r="92"/>
          <circle cx="320" cy="560" r="44"/>
        </g>
        <g stroke="#a53b45" stroke-width="8" opacity="0.22" fill="none">
          <path d="M80 620c120-170 260-260 430-310"/>
          <path d="M920 110C780 250 670 330 510 400"/>
        </g>
        <g fill="#fff8f7" opacity="0.74">
          <circle cx="155" cy="125" r="12"/>
          <circle cx="815" cy="160" r="10"/>
          <circle cx="675" cy="490" r="14"/>
        </g>
      </svg>
    `),
  },
];

export const CUSTOM_BACKGROUND_OPTION = "custom";
export const NO_BACKGROUND_OPTION = "none";

export const getThemeSelectionValue = (backgroundImageUrl) => {
  if (!backgroundImageUrl) return NO_BACKGROUND_OPTION;
  const preset = LABEL_BACKGROUND_THEMES.find(
    (item) => item.url === backgroundImageUrl,
  );
  return preset ? preset.key : CUSTOM_BACKGROUND_OPTION;
};

export const findThemeByKey = (themeKey) =>
  LABEL_BACKGROUND_THEMES.find((item) => item.key === themeKey) || null;